module.exports = __webpack_public_path__ + "static/img/contact-map.4b14327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact-map.png
// module id = Ci+7
// module chunks = 1